'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FAILED = exports.FAILED = 'FAILED';
var OUT_OF_SYNC = exports.OUT_OF_SYNC = 'OUT_OF_SYNC';
var STARTED = exports.STARTED = 'STARTED';
var SUCCEEDED = exports.SUCCEEDED = 'SUCCEEDED';
var UNINITIALIZED = exports.UNINITIALIZED = 'UNINITIALIZED';